(function () {
  if (window.__ampGiftOptionsInitialized) return;
  window.__ampGiftOptionsInitialized = true;

  // Wrap products, in display order. The first is the existing product; the second shows up as soon as a
  // product with that handle exists in Shopify (missing ones are skipped).
  var WRAP_HANDLES = ['emballage-cadeau', 'coffret-prestige'];
  var WRAP_DESC_KEYS = { 'emballage-cadeau': 'wrapDesc', 'coffret-prestige': 'boxDesc' };
  var WRAP_MAX = 10; // most wraps of one kind per order. Placeholder until the client confirms the rule.
  var NOTE_HANDLE = 'le-mot-personnalise';
  var NOTE_MAX = 200;
  var PROP_MESSAGE = 'Message';

  var TEXT = {
    fr: {
      row: "C'est pour offrir ?",
      title: 'Options cadeaux',
      intro: 'Un emballage signé de la Maison, un mot personnel si vous le souhaitez. Un emballage par cadeau : pour offrir vos produits séparément, ajoutez-en un par destinataire.',
      wrapSection: 'Emballage cadeau',
      wrapDesc: 'Vos produits glissés dans la pochette Plisson. Convient à un set de rasage complet ou à une brosse à cheveux.',
      boxDesc: 'Vos produits présentés dans le coffret Plisson : un blaireau et son bol, ou un blaireau ou un rasoir avec deux soins.',
      noteSection: 'Mot personnalisé',
      noteDesc: 'Votre message sur une carte Plisson, glissé dans le colis.',
      free: 'Offert',
      propMessage: 'Message',
      add: 'Ajouter',
      added: 'Ajouté',
      remove: 'Retirer',
      message: 'Entrez votre message',
      maxChars: '200 caractères maximum',
      del: 'Supprimer',
      submit: 'Ajouter au panier',
      close: 'Fermer',
      required: 'Veuillez écrire votre message.',
      error: 'Une erreur est survenue, veuillez réessayer.',
      less: 'Retirer un',
      more: 'Ajouter un'
    },
    en: {
      row: 'Is it a gift?',
      title: 'Gift options',
      intro: 'Packaging signed by the Maison, and a personal note if you wish. One packaging per gift: to give your products separately, add one per recipient.',
      wrapSection: 'Gift wrap',
      wrapDesc: 'Your products slipped into the Plisson pouch. Suits a complete shaving set or a hair brush.',
      boxDesc: 'Your products presented in the Plisson gift box: a brush and its bowl, or a brush or a razor with two care products.',
      noteSection: 'Personal note',
      noteDesc: 'Your message on a Plisson card, slipped into the parcel.',
      free: 'Free',
      propMessage: 'Message',
      add: 'Add',
      added: 'Added',
      remove: 'Remove',
      message: 'Enter your message',
      maxChars: '200 characters maximum',
      del: 'Remove',
      submit: 'Add to cart',
      close: 'Close',
      required: 'Please write your message.',
      error: 'Something went wrong, please try again.',
      less: 'Remove one',
      more: 'Add one'
    },
    de: {
      row: 'Ist es ein Geschenk?',
      title: 'Geschenkoptionen',
      intro: 'Eine Verpackung mit der Signatur des Hauses und, wenn Sie möchten, eine persönliche Notiz. Eine Verpackung pro Geschenk: Um Ihre Produkte getrennt zu verschenken, fügen Sie pro Empfänger eine hinzu.',
      wrapSection: 'Geschenkverpackung',
      wrapDesc: 'Ihre Produkte in der Plisson-Pochette. Passend für ein komplettes Rasierset oder eine Haarbürste.',
      boxDesc: 'Ihre Produkte im Plisson-Geschenkkoffer: ein Pinsel mit Schale oder ein Pinsel oder Rasierer mit zwei Pflegeprodukten.',
      noteSection: 'Persönliche Notiz',
      noteDesc: 'Ihre Nachricht auf einer Plisson-Karte, dem Paket beigelegt.',
      free: 'Gratis',
      propMessage: 'Nachricht',
      add: 'Hinzufügen',
      added: 'Hinzugefügt',
      remove: 'Entfernen',
      message: 'Ihre Nachricht',
      maxChars: 'Maximal 200 Zeichen',
      del: 'Entfernen',
      submit: 'In den Warenkorb',
      close: 'Schließen',
      required: 'Bitte schreiben Sie Ihre Nachricht.',
      error: 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
      less: 'Eines entfernen',
      more: 'Eines hinzufügen'
    },
    es: {
      row: '¿Es para regalo?',
      title: 'Opciones de regalo',
      intro: 'Un envoltorio con la firma de la Maison y, si lo desea, una nota personal. Un envoltorio por regalo: para regalar sus productos por separado, añada uno por destinatario.',
      wrapSection: 'Envoltorio de regalo',
      wrapDesc: 'Sus productos en la funda Plisson. Ideal para un set de afeitado completo o un cepillo para el pelo.',
      boxDesc: 'Sus productos presentados en el estuche Plisson: una brocha y su cuenco, o una brocha o una maquinilla con dos cuidados.',
      noteSection: 'Nota personalizada',
      noteDesc: 'Su mensaje en una tarjeta Plisson, incluida en el paquete.',
      free: 'Gratis',
      propMessage: 'Mensaje',
      add: 'Añadir',
      added: 'Añadido',
      remove: 'Quitar',
      message: 'Escriba su mensaje',
      maxChars: '200 caracteres como máximo',
      del: 'Quitar',
      submit: 'Añadir al carrito',
      close: 'Cerrar',
      required: 'Escriba su mensaje.',
      error: 'Ha ocurrido un error, inténtelo de nuevo.',
      less: 'Quitar uno',
      more: 'Añadir uno'
    },
    it: {
      row: 'È un regalo?',
      title: 'Opzioni regalo',
      intro: 'Una confezione firmata dalla Maison e, se lo desidera, un biglietto personale. Una confezione per regalo: per regalare i prodotti separatamente, ne aggiunga una per destinatario.',
      wrapSection: 'Confezione regalo',
      wrapDesc: 'I suoi prodotti nella pochette Plisson. Adatta a un set da barba completo o a una spazzola per capelli.',
      boxDesc: 'I suoi prodotti presentati nel cofanetto Plisson: un pennello e la sua ciotola, oppure un pennello o un rasoio con due trattamenti.',
      noteSection: 'Biglietto personalizzato',
      noteDesc: 'Il suo messaggio su un biglietto Plisson, inserito nel pacco.',
      free: 'Gratis',
      propMessage: 'Messaggio',
      add: 'Aggiungi',
      added: 'Aggiunto',
      remove: 'Rimuovi',
      message: 'Scriva il suo messaggio',
      maxChars: 'Massimo 200 caratteri',
      del: 'Rimuovi',
      submit: 'Aggiungi al carrello',
      close: 'Chiudi',
      required: 'Scriva il suo messaggio.',
      error: 'Si è verificato un errore, riprovi.',
      less: 'Rimuovi uno',
      more: 'Aggiungi uno'
    }
  };

  var ICON_GIFT =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20 7h-2.2A3 3 0 0 0 12 4.8 3 3 0 0 0 6.2 7H4a1 1 0 0 0-1 1v3h8V7h2v4h8V8a1 1 0 0 0-1-1zM9 7a1 1 0 1 1 1-1v1H9zm6 0h-1V6a1 1 0 1 1 1 1zM4 13v6a1 1 0 0 0 1 1h6v-7H4zm9 0v7h6a1 1 0 0 0 1-1v-6h-7z"/></svg>';
  var ICON_ARROW =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 12h16M14 6l6 6-6 6"/></svg>';
  var ICON_CLOSE =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  var productsPromise = null;
  var panel = null;
  var lastFocus = null;
  var state = null;

  function getShortLang() {
    // <html lang> reflects what the page and SlideCart are actually rendered in
    var htmlLang = document.documentElement.getAttribute('lang');
    if (htmlLang) return htmlLang.toLowerCase().split('-')[0];

    var pathMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/i);
    if (pathMatch) return pathMatch[1].toLowerCase();

    var locale = window.Shopify && window.Shopify.locale;
    if (locale) return locale.toLowerCase().split('-')[0];

    return 'fr';
  }

  function isWrapHandle(handle) {
    return WRAP_HANDLES.indexOf(handle) !== -1;
  }

  function isGiftHandle(handle) {
    return isWrapHandle(handle) || handle === NOTE_HANDLE;
  }

  // A line is over its limit when a note has more than 1 or a wrap has more than WRAP_MAX
  function overLimit(item) {
    return item.handle === NOTE_HANDLE ? item.quantity > 1 : item.quantity > WRAP_MAX;
  }

  function t(key) {
    var dict = TEXT[getShortLang()] || TEXT.en;
    return dict[key] || TEXT.en[key] || key;
  }

  function getRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    try {
      return new Intl.NumberFormat((window.Shopify && window.Shopify.locale) || 'fr', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return String(cents / 100);
    }
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error(String(response.status));
      return response.json();
    });
  }

  function loadProducts() {
    if (productsPromise) return productsPromise;

    function load(handle) {
      return fetchJson(getRoot() + 'products/' + handle + '.js').catch(function () {
        return null;
      });
    }

    productsPromise = Promise.all(WRAP_HANDLES.concat([NOTE_HANDLE]).map(load)).then(function (results) {
      var note = results.pop();
      return {
        wraps: results.filter(function (product) {
          return Boolean(product);
        }),
        note: note
      };
    });

    return productsPromise;
  }

  function getCart() {
    return fetchJson(getRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
  }

  function findLine(cart, handle) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i += 1) {
      if (items[i].handle === handle) return items[i];
    }
    return null;
  }

  function firstVariant(product) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i += 1) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0] || null;
  }

  function imageUrl(product) {
    var src = product && product.featured_image;
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=320';
  }

  function priceLabel(product) {
    var variant = firstVariant(product);
    if (!variant || !variant.price) return t('free');
    return formatMoney(variant.price);
  }

  /* ---------- Cart row (injected in SlideCart) ---------- */

  function buildRow() {
    var row = el('div', 'plisson-gift-row');
    var button = el('button', 'plisson-gift-row__button');
    button.type = 'button';
    button.setAttribute('aria-haspopup', 'dialog');

    var icon = el('span', 'plisson-gift-row__icon');
    icon.innerHTML = ICON_GIFT;

    var text = el('span', 'plisson-gift-row__text');
    var label = el('span', 'plisson-gift-row__label', t('row'));
    var status = el('span', 'plisson-gift-row__status');
    status.hidden = true;
    text.appendChild(label);
    text.appendChild(status);

    var arrow = el('span', 'plisson-gift-row__arrow');
    arrow.innerHTML = ICON_ARROW;

    button.appendChild(icon);
    button.appendChild(text);
    button.appendChild(arrow);
    button.addEventListener('click', function () {
      openPanel(button);
    });

    row.appendChild(button);
    return row;
  }

  function updateRowStatus(row) {
    var label = row.querySelector('.plisson-gift-row__label');
    if (label && label.textContent !== t('row')) label.textContent = t('row');

    var status = row.querySelector('.plisson-gift-row__status');
    if (!status || typeof window.SLIDECART_STATE !== 'function') return;

    var cart;
    try {
      cart = window.SLIDECART_STATE().cart;
    } catch (e) {
      return;
    }

    var names = [];
    var cartItems = (cart && cart.items) || [];
    if (cartItems.some(function (item) { return isWrapHandle(item.handle); })) names.push(t('wrapSection'));
    if (findLine(cart, NOTE_HANDLE)) names.push(t('noteSection'));

    var text = names.join(' · ');
    if (status.textContent !== text) status.textContent = text;
    status.hidden = names.length === 0;
  }

  /* Gift lines are free, so:
     - a cart holding only gifts must not reach checkout: once the last real product is removed,
       the gift lines go too;
     - a note is a single item and a wrap is capped at WRAP_MAX: anything above is brought back down. */
  var isMaintaining = false;

  function maintainGifts() {
    if (isMaintaining || typeof window.SLIDECART_STATE !== 'function') return;

    var stateCart;
    try {
      stateCart = window.SLIDECART_STATE().cart;
    } catch (e) {
      return;
    }

    var stateItems = (stateCart && stateCart.items) || [];
    var stateGifts = stateItems.filter(function (item) {
      return isGiftHandle(item.handle);
    });
    if (!stateGifts.length) return;

    var onlyGifts = stateGifts.length === stateItems.length;
    var tooMany = stateGifts.some(overLimit);
    if (!onlyGifts && !tooMany) return;

    isMaintaining = true;

    // Confirm against the live cart so a stale SlideCart state never changes gifts by mistake
    getCart()
      .then(function (cart) {
        var gifts = cart.items.filter(function (item) {
          return isGiftHandle(item.handle);
        });
        var hasOtherItems = gifts.length !== cart.items.length;
        var updates = {};
        var changed = false;

        gifts.forEach(function (item) {
          if (!hasOtherItems) {
            updates[item.key] = 0;
            changed = true;
          } else if (overLimit(item)) {
            updates[item.key] = item.handle === NOTE_HANDLE ? 1 : WRAP_MAX;
            changed = true;
          }
        });

        if (!changed) return null;

        return fetchJson(getRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
        });
      })
      .catch(function () {})
      .then(function () {
        isMaintaining = false;
      });
  }

  /* Mark gift lines; the note is a single item, so the stylesheet hides its stepper (wraps keep theirs) */
  function tagGiftLines(root) {
    var lines = root.querySelectorAll('.items .item');
    for (var i = 0; i < lines.length; i += 1) {
      var link = lines[i].querySelector('a[href*="/products/"]');
      var href = link ? link.getAttribute('href').split('?')[0] : '';
      var handle = href.split('/').pop();
      var isGift = isGiftHandle(handle);
      lines[i].classList.toggle('plisson-gift-line', isGift);
      lines[i].classList.toggle('plisson-gift-line--single', handle === NOTE_HANDLE);

      if (isGift) {
        showFreeLabel(lines[i]);
        translatePropertyNames(lines[i]);
      }
    }
  }

  /* The stored property names stay French (so the packing team always reads the same labels);
     only what the customer sees in the cart is translated. */
  function translatePropertyNames(line) {
    var labels = { Message: 'propMessage' };
    var rows = line.querySelectorAll('.properties-key-value li[data-key]');

    for (var i = 0; i < rows.length; i += 1) {
      var key = labels[rows[i].getAttribute('data-key')];
      var keyEl = rows[i].querySelector('.properties-key-value-key');
      if (key && keyEl && keyEl.textContent !== t(key)) keyEl.textContent = t(key);
    }
  }

  /* A free gift line reads "Offert" (localised) instead of "0,00 €".
     SlideCart re-renders the price now and then, so this runs on every tick and only writes when needed. */
  function showFreeLabel(line) {
    var price = line.querySelector('.main-bottom .price:not(.strike-through)');
    if (!price) return;

    var label = t('free');
    var current = price.textContent.trim();
    if (current === label) return;

    // Only replace a genuine zero price, never a real amount if the gift ever becomes paid
    if (/^0+$/.test(current.replace(/[^0-9]/g, '')) && /\d/.test(current)) price.textContent = label;
  }

  function ensureRow() {
    var root = document.getElementById('slidecarthq');
    if (!root) return;

    var items = root.querySelector('.items');
    var existing = root.querySelector('.plisson-gift-row');

    if (!items) {
      if (existing) existing.remove();
      return;
    }

    tagGiftLines(root);

    if (!existing) existing = buildRow();
    if (existing.previousElementSibling !== items) items.insertAdjacentElement('afterend', existing);

    try {
      updateRowStatus(existing);
    } catch (e) {}
  }

  /* ---------- Panel ---------- */

  function ensurePanel() {
    if (panel) return panel;

    panel = el('div', 'plisson-gift-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-hidden', 'true');

    var overlay = el('div', 'plisson-gift-panel__overlay');
    overlay.addEventListener('click', closePanel);

    var sheet = el('div', 'plisson-gift-panel__sheet');
    panel.appendChild(overlay);
    panel.appendChild(sheet);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });

    return panel;
  }

  function setSlideCartInert(value) {
    var slideCart = document.getElementById('slidecarthq');
    if (slideCart) slideCart.inert = value;
  }

  function closePanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    setSlideCartInert(false);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function openPanel(trigger) {
    lastFocus = trigger || null;
    ensurePanel();

    // Re-append so the panel always stacks above SlideCart (same z-index, later in DOM)
    document.body.appendChild(panel);

    Promise.all([loadProducts(), getCart()])
      .then(function (results) {
        renderPanel(results[0], results[1]);
        panel.setAttribute('aria-hidden', 'false');
        // SlideCart's focus trap pulls focus back into its drawer, which breaks typing in our inputs
        setSlideCartInert(true);
        // force reflow so the slide-in transition runs
        void panel.offsetWidth;
        panel.classList.add('is-open');
        var closeButton = panel.querySelector('.plisson-gift-panel__close');
        if (closeButton) closeButton.focus();
      })
      .catch(function () {});
  }

  function readProps(line) {
    var props = (line && line.properties) || {};
    return {
      message: props[PROP_MESSAGE] || ''
    };
  }

  /* Description written in Shopify admin (and translated there), plain text. It takes priority over the built-in line. */
  function productDescription(product) {
    var html = (product && product.description) || '';
    if (!html) return '';

    try {
      return (new DOMParser().parseFromString(html, 'text/html').body.textContent || '').trim();
    } catch (e) {
      return '';
    }
  }

  function buildProductRow(product, fallbackDescription) {
    var row = el('div', 'plisson-gift-panel__product');

    var imageWrap = el('div', 'plisson-gift-panel__image');
    var src = imageUrl(product);
    if (src) {
      var img = el('img');
      img.src = src;
      img.alt = product.title || '';
      img.loading = 'lazy';
      imageWrap.appendChild(img);
    }

    var body = el('div', 'plisson-gift-panel__body');
    var head = el('div', 'plisson-gift-panel__product-head');
    head.appendChild(el('span', 'plisson-gift-panel__product-title', product.title));
    head.appendChild(el('span', 'plisson-gift-panel__price', priceLabel(product)));
    body.appendChild(head);

    var description = productDescription(product) || fallbackDescription || '';
    if (description) body.appendChild(el('p', 'plisson-gift-panel__desc', description));

    row.appendChild(imageWrap);
    row.appendChild(body);
    return { row: row, body: body };
  }

  function renderPanel(products, cart) {
    var sheet = panel.querySelector('.plisson-gift-panel__sheet');
    sheet.textContent = '';

    var noteLine = findLine(cart, NOTE_HANDLE);
    var noteProps = readProps(noteLine);

    state = {
      noteOn: Boolean(noteLine),
      message: noteProps.message
    };

    var header = el('div', 'plisson-gift-panel__header');
    header.appendChild(el('h2', 'plisson-gift-panel__title', t('title')));
    var closeButton = el('button', 'plisson-gift-panel__close');
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', t('close'));
    closeButton.innerHTML = ICON_CLOSE;
    closeButton.addEventListener('click', closePanel);
    header.appendChild(closeButton);

    var content = el('div', 'plisson-gift-panel__content');
    content.appendChild(el('p', 'plisson-gift-panel__intro', t('intro')));

    var errorBox = el('p', 'plisson-gift-panel__error');
    errorBox.setAttribute('role', 'alert');
    errorBox.hidden = true;

    // Created at the end; declared here because the note section toggles it
    var footer = null;

    /* Wrap section: one row per wrap product, each with its own quantity (applied to the cart immediately) */
    if (products.wraps.length) {
      var wrapSection = el('section', 'plisson-gift-panel__section');
      wrapSection.appendChild(el('h3', 'plisson-gift-panel__section-title', t('wrapSection')));

      products.wraps.forEach(function (wrapProduct) {
        var wrapParts = buildProductRow(wrapProduct, t(WRAP_DESC_KEYS[wrapProduct.handle] || 'wrapDesc'));
        wrapParts.body.appendChild(buildWrapQuantity(wrapProduct, wrapLineQuantity(cart, wrapProduct.handle), errorBox));
        wrapSection.appendChild(wrapParts.row);
      });

      content.appendChild(wrapSection);
    }

    /* Note section */
    if (products.note) {
      var noteSection = el('section', 'plisson-gift-panel__section');
      noteSection.appendChild(el('h3', 'plisson-gift-panel__section-title', t('noteSection')));

      var noteParts = buildProductRow(products.note, t('noteDesc'));
      var noteButton = el('button', 'plisson-gift-panel__btn');
      noteButton.type = 'button';
      noteParts.body.appendChild(noteButton);
      noteSection.appendChild(noteParts.row);

      var form = el('div', 'plisson-gift-panel__note-form');

      var textarea = el('textarea', 'plisson-gift-panel__input plisson-gift-panel__textarea');
      textarea.rows = 4;
      textarea.maxLength = NOTE_MAX;
      textarea.placeholder = t('message') + '*';
      textarea.setAttribute('aria-label', t('message'));
      textarea.value = state.message;

      var meta = el('div', 'plisson-gift-panel__note-meta');
      var counter = el('span', 'plisson-gift-panel__counter');
      var delButton = el('button', 'plisson-gift-panel__link', t('del'));
      delButton.type = 'button';
      meta.appendChild(counter);
      meta.appendChild(delButton);

      var syncCounter = function () {
        counter.textContent = t('maxChars') + ' (' + textarea.value.length + '/' + NOTE_MAX + ')';
      };
      textarea.addEventListener('input', function () {
        state.message = textarea.value;
        syncCounter();
      });
      syncCounter();

      form.appendChild(textarea);
      form.appendChild(meta);
      noteSection.appendChild(form);

      var syncNote = function () {
        if (footer) footer.hidden = !state.noteOn;
        form.hidden = !state.noteOn;
        noteButton.hidden = state.noteOn;
        noteButton.textContent = t('add');
      };
      noteButton.addEventListener('click', function () {
        state.noteOn = true;
        syncNote();
        textarea.focus();
      });
      delButton.addEventListener('click', function () {
        state.noteOn = false;
        state.message = '';
        textarea.value = '';
        syncCounter();
        syncNote();
      });
      syncNote();

      content.appendChild(noteSection);
    }

    content.appendChild(errorBox);

    footer = el('div', 'plisson-gift-panel__footer');
    footer.hidden = !(products.note && state.noteOn);
    var submit = el('button', 'plisson-gift-panel__submit', t('submit'));
    submit.type = 'button';
    submit.addEventListener('click', function () {
      submitSelection(products, submit, errorBox);
    });
    footer.appendChild(submit);

    sheet.appendChild(header);
    sheet.appendChild(content);
    sheet.appendChild(footer);
  }

  function showError(errorBox, message) {
    errorBox.textContent = message;
    errorBox.hidden = !message;
  }

  function sameNote(line, props) {
    var current = readProps(line);
    return current.message === props[PROP_MESSAGE];
  }

  function updateSlideCartQuietly() {
    if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
  }

  function wrapLineQuantity(cart, handle) {
    var line = findLine(cart, handle);
    return line ? line.quantity : 0;
  }

  // Sets the quantity of one wrap in the cart (0 removes it)
  function applyWrapQuantity(product, quantity) {
    return getCart()
      .then(function (cart) {
        var line = findLine(cart, product.handle);

        if (line) {
          var updates = {};
          updates[line.key] = quantity;
          return fetchJson(getRoot() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        }

        if (quantity > 0) {
          var variant = firstVariant(product);
          if (!variant) throw new Error('no variant');
          return fetchJson(getRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: quantity }] })
          });
        }

        return null;
      })
      .then(updateSlideCartQuietly);
  }

  // "- 0 +" control. Every click is applied to the cart straight away, so the number is what is in the cart.
  function buildWrapQuantity(product, initialQuantity, errorBox) {
    var quantity = initialQuantity;
    var busy = false;

    var control = el('div', 'plisson-gift-panel__qty');
    var minus = el('button', 'plisson-gift-panel__qty-btn', '\u2212');
    var value = el('span', 'plisson-gift-panel__qty-value');
    var plus = el('button', 'plisson-gift-panel__qty-btn', '+');
    minus.type = 'button';
    plus.type = 'button';
    minus.setAttribute('aria-label', t('less') + ' ' + product.title);
    plus.setAttribute('aria-label', t('more') + ' ' + product.title);
    value.setAttribute('aria-live', 'polite');

    var sync = function () {
      value.textContent = String(quantity);
      minus.disabled = busy || quantity <= 0;
      plus.disabled = busy || quantity >= WRAP_MAX;
    };

    var change = function (next) {
      if (busy || next < 0 || next > WRAP_MAX) return;
      busy = true;
      showError(errorBox, '');
      sync();

      applyWrapQuantity(product, next)
        .then(function () {
          quantity = next;
        })
        .catch(function () {
          showError(errorBox, t('error'));
        })
        .then(function () {
          busy = false;
          sync();
        });
    };

    minus.addEventListener('click', function () {
      change(quantity - 1);
    });
    plus.addEventListener('click', function () {
      change(quantity + 1);
    });

    control.appendChild(minus);
    control.appendChild(value);
    control.appendChild(plus);
    sync();
    return control;
  }

  function refreshSlideCart() {
    if (typeof window.SLIDECART_UPDATE === 'function') {
      window.SLIDECART_UPDATE(function () {
        if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        ensureRow();
      });
    }
  }

  function submitSelection(products, submitButton, errorBox) {
    showError(errorBox, '');

    var noteProps = {};
    noteProps[PROP_MESSAGE] = state.message.trim().slice(0, NOTE_MAX);

    if (state.noteOn && !noteProps[PROP_MESSAGE]) {
      showError(errorBox, t('required'));
      return;
    }

    submitButton.disabled = true;

    getCart()
      .then(function (cart) {
        var noteLine = findLine(cart, NOTE_HANDLE);
        var removals = {};
        var hasRemovals = false;
        var additions = [];

        if (!state.noteOn && noteLine) {
          removals[noteLine.key] = 0;
          hasRemovals = true;
        }
        if (state.noteOn && !(noteLine && sameNote(noteLine, noteProps))) {
          if (noteLine) {
            removals[noteLine.key] = 0;
            hasRemovals = true;
          }
          var noteVariant = firstVariant(products.note);
          if (noteVariant) additions.push({ id: noteVariant.id, quantity: 1, properties: noteProps });
        }

        var chain = Promise.resolve();

        if (hasRemovals) {
          chain = chain.then(function () {
            return fetchJson(getRoot() + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: removals })
            });
          });
        }

        if (additions.length) {
          chain = chain.then(function () {
            return fetchJson(getRoot() + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: additions })
            });
          });
        }

        return chain;
      })
      .then(function () {
        submitButton.disabled = false;
        closePanel();
        refreshSlideCart();
      })
      .catch(function () {
        submitButton.disabled = false;
        showError(errorBox, t('error'));
      });
  }

  /* ---------- SlideCart hooks ---------- */

  var rowTimer;

  function scheduleRow() {
    window.clearTimeout(rowTimer);
    rowTimer = window.setTimeout(ensureRow, 0);
  }

  function observeSlideCart() {
    var root = document.getElementById('slidecarthq');
    if (!root || root.__ampGiftObserver) return;

    // ensureRow is idempotent (no-op once the row is in place), so no re-entry guard is needed
    root.__ampGiftObserver = new MutationObserver(scheduleRow);

    root.__ampGiftObserver.observe(root, { childList: true, subtree: true });
  }

  function chainCallback(name, fn) {
    var previous = window[name];
    window[name] = function () {
      if (typeof previous === 'function') previous.apply(this, arguments);
      fn.apply(this, arguments);
    };
  }

  function bootstrap() {
    observeSlideCart();
    scheduleRow();
  }

  // Safety net: SlideCart can rebuild or replace its markup without firing the callbacks above.
  // ensureRow is a cheap no-op when the row is already in place.
  window.setInterval(function () {
    observeSlideCart();
    ensureRow();
    maintainGifts();
  }, 500);

  chainCallback('SLIDECART_LOADED', bootstrap);
  chainCallback('SLIDECART_UPDATED', scheduleRow);
  chainCallback('SLIDECART_OPENED', scheduleRow);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
